import React, { useState, useEffect, useCallback } from "react";
import TableWrapper from "../../../core/BaseComponents/TableWrapper/TableWrapper";
import { Card, CircularProgress, Switch } from "@mui/material";
import { callAPI } from "../../../../axios";
import Custom_Paingation from "../../../core/BaseComponents/Custom_Paingation";
import { useSelector } from "react-redux";
import { debounce } from 'lodash';
import { getChainIdLS, formatHotelDisplayName } from "../../../../utils/utils";
import dayjs from "dayjs";
import BasicModal from "../../../core/BaseComponents/Modal";

function AutomodeDashboard() {
  const [apkMappingList, setApkMappingList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [cdnsShowPopUp, setCdnsShowPopUp] = useState(false);
  const [rowData, setRowData] = useState(false);

  const recordsPerPage = 10;

  const { chainId } = useSelector((state) => state.chainIdReducer);
  const { viewType } = useSelector((state) => state.viewTypeReducer);

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("")
  const [inputPageValue, setInputPageValue] = useState(1)


  const [searchText, setSearchText] = useState("")
  const [fromApkVersion, setFromApkVersion] = useState([])
  // const [debouncedSearchText, setDebouncedSearchText] = useState('');
  // const [searchTextValidation, setSearchTextValidation] = useState("");
  const [apkVersionFilter, setApkVersionFilter] = useState("All")

  const fromVersionApi = () =>{
      callAPI('/autoModeDashboard', "GET", {}, { chainId: getChainIdLS() })
      .then((response) => {
        setFromApkVersion(response)
      })
      .catch((err) => console.warn(err.message));
  }

  useEffect(() => {
    fromVersionApi()
    setSearchText("")
  }, [chainId]);

  const hotelListApi = () => {
      const apiPath = `hotel/search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
      setLoader(true);
      callAPI(apiPath, "POST", { hotelName: searchText, priority: apkVersionFilter, isDashboardPage: true , isAutomodeDashboardPage: true })
        .then((response) => {
          setApkMappingList(response?.hotelDetails?.map((data)=>({...data, sid:data.id})));
          setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
          setPaginationError("")
          setLoader(false);
        })
        .catch((err) => { console.warn(err.message); setLoader(false); });
    };

  useEffect(() => {
    hotelListApi();
  }, [selectedPage, chainId, searchText, apkVersionFilter]);

  useEffect(() => {
    setInputPageValue(1)
    setPaginationError("")
    setSelectedPage(1);
  }, [searchText, apkVersionFilter]);

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value)
    setPaginationError("")
    setSelectedPage(value);
  };

  const renderCDSNS = (row) => {
    const [item, ...items] = row?.cdsns;
    return row?.cdsns?.length > 0 ? <span className="cursor-pointer" onClick={() => { setCdnsShowPopUp(true); setRowData(row) }}>{item} {items.length > 0 && (
      <><span>...</span><span className="ms-2 cdsn-count">+{items?.length}</span></>
    )}</span> : (
      <div>N.A</div>
    )
  }

  const columns = [
      {
        field: "hotelName",
        headerName: "Hotel Name",
        flex: 1,
        row: true,
        renderCell: (row) => formatHotelDisplayName(row),
      },
      { field: "contactNo", headerName: "Phone", flex: 1 },
      { field: "email", headerName: "Email", flex: 1 },
      { field: "entepriseChainId", headerName: "Chain ID", flex: 1 },
      {
        field: "CDSN", headerName: "Linked CDSNs", flex: 1,
        row: true, renderCell: renderCDSNS,
        sortDirection: false,
        disableSortIcon: true
      },
      {
        field: "logoUrl", headerName: "Logo", flex: 1,
        row: true, renderCell: (row) => row?.logoUrl === null ? "NA" : <div className="uploaded-image">
          <img src={row?.logoUrl} alt={row?.logoUrl} />
        </div>,
        sortDirection: false,
        disableSortIcon: true
      },
      {
        field: "autoMode", headerName: "Auto Mode Status", flex: 1,
        row: true, renderCell: (row) => <Switch
            checked={row?.autoMode}
            disabled
            inputProps={{ "aria-label": "controlled" }}
            className={`${row?.autoMode ? 'switchuser-active' : 'switchuser-inactive'} edit-icon-disable`}
          />,
        sortDirection: false,
        disableSortIcon: true
      },
    ];

    const handleSearch = (search) => {
      setSearchText(search)
    };
  
    const delayedSearch = useCallback(
      debounce((searchText) => handleSearch(searchText), 600),
      []
    );

    const DownloadTextFile = (headings, fileName) => {
      const columnHeaders = 'CDSN\n';
      const textArray = headings?.map((category) => {
        const categoryText = `${category?.header}\n`; // Section heading
        const categoryBody = category?.body?.map((item) =>
          `${item?.length ? item : 'NA'}`)?.join('\n'); // Data rows with SID and CDSN
        return `${categoryText}${columnHeaders}${categoryBody || 'No data available'}\n`; // Include the column headers before the data
      });
  
      const fileText = textArray?.join('\n');
      const blob = new Blob([fileText], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    };

    const downLoadFile = () => {
      const fileName = `${rowData?.hotelName}_${rowData?.hotelChainId}_CDSNs.csv`;
      const headings = [
        { header: `List of "${rowData?.hotelName}" Linked CDSN's`, body: rowData?.cdsns?.length ? rowData?.cdsns : [{ sid: 'NA', cdsn: ['NA'] }] }
      ];
      DownloadTextFile(headings, fileName);
    };

  return (
    <>
      <p className="mb-1 ms-1"><b>Automode Priority Dashboard</b></p>
      <div className="hotel-dashboard ms-1">
        {fromApkVersion?.map((data)=>{
          return (
          <Card className={`cursor-pointer ${apkVersionFilter == data?.key ? "activeHotelFilter" : ""}`} onClick={() => setApkVersionFilter(data?.key)}>
            <strong>Priority : {data?.key==="All" ? "ALL Hotels": data?.key}</strong>
            <p>Count: {data?.count}</p>
          </Card>
          )
        })}
      </div>
      <div className='row config-hotel'>
        <div className='col-12 left-column'>
          {loader && <div className="circular-progress"><CircularProgress /></div>}
          <div className="hotel-list">
            <div className="flex-items-between mb-3">
              <p className="mb-0"><b>Hotel List</b></p>
              <div className="d-flex">
              <div className="form-group-hotel mb-0">
                  <div className={`floating-label`}>
                    <input
                      id="search"
                      placeholder=""
                      className="form-control"
                      onChange={(e) => {
                        const value = e.target.value;
                        delayedSearch(value)
                      }}
                    />
                    <label htmlFor="guestName">Search Hotel</label>
                  </div>
                </div>
                  {/* {searchTextValidation && (
                      <small className="required">{searchTextValidation}</small>
                  )} */}
              </div>
            </div>
            <TableWrapper
              data={apkMappingList}
              columns={columns}
              module=""
              noPagination={true}
            />
            <Custom_Paingation
              selectedPage={selectedPage}
              totalPageCount={totalPageCount}
              paginationError={paginationError}
              inputPageValue={inputPageValue}
              setSelectedPage={setSelectedPage}
              setPaginationError={setPaginationError}
              setInputPageValue={setInputPageValue}
              onPageChange={onPageChange}
            />
            {cdnsShowPopUp && <BasicModal
              popupOpen={cdnsShowPopUp}
              bodyMessage={
                <div className="text-start">
                  <p className="px-3 pt-3">List of "<b>{rowData?.hotelName}</b>" Linked CDSNs</p>
                  <div className="linked-sid-cdsns">
                    <div className="sid-cdsn-list">
                      <div className="row sid-cdsn-list-header">
                        <h6 className="text-start">CDSN's</h6>
                      </div>
                      <div className="my-3 px-3">
                        {rowData?.cdsns?.map((items, index) =>
                          <span className="mb-1">{index ? ', ' : ''} {items}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              }
              customcss={true}
              footer={
                {
                  primaryButton: {
                    buttonName: "Cancel",
                    action: ()=>setCdnsShowPopUp(false),
                    buttonPrimaryCustomCss: 'cancel-btn_new'
                  }
                  ,
                  secondaryButton: {
                    buttonName: "Download",
                    action: downLoadFile
                  }
                }
              }
            />}
          </div>
        </div>
      </div>
    </>
  )
}

export default AutomodeDashboard;